// import { callAjax } from './ajax'
// import { isMobileDevice } from '../utils/is-mobile-device'

// const target = {
//   latitude: 0,
//   longitude: 0
// }

const options = {
  enableHighAccuracy: true,
  // timeout: 10000,
  timeout: 10000,
  maximumAge: 30000,
}

function activateGeolocateMobile() {
  return new Promise((resolve, reject) => {
    const error = err => {
      console.warn(`ERROR(${err.code}): ${err.message}`)
      console.warn(`Reason: ${err.message}, Mobile->No geolocation, go by desktopRedirect`)

      // eslint-disable-next-line prefer-promise-reject-errors
      reject(`reject Reason: ${err.message}`)
      // window.location.href = '/tickets'
    }

    if ('geolocation' in navigator) {
      // const watchID = navigator.geolocation.watchPosition(position => {
      //   console.info(position.coords.latitude, position.coords.longitude)
      // })
      // let city = {}
      const success = pos => {
        const crd = pos.coords
        // const crd = JSON.parse(pos.coords)
        // setCookie('lt', crd.latitude, 365, '')
        // setCookie('lg', crd.longitude, 365, '')
        console.debug(crd.latitude, crd.longitude)
        // city.latitude = crd.latitude
        // city.longitude = crd.longitude
        // city.push(crd.latitude, crd.longitude)
        const city = {
          lt: crd.latitude,
          lg: crd.longitude,
        }
        console.debug(`activateGeolocateMobile: ${city.lt}`)
        navigator.geolocation.clearWatch(id)
        resolve(city)
      }

      const id = navigator.geolocation.watchPosition(success, error, options)
    } else {
      console.debug(`No geolocation`)
      // eslint-disable-next-line prefer-promise-reject-errors
      reject(`No geolocation`)
    }
    // return city = null
  })
}

export default activateGeolocateMobile
